import { useState, useCallback } from 'react';
import apiService from '../../../services/ApiService';

export const useAdminData = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [metrics, setMetrics] = useState({});

  const loadMetrics = useCallback(async () => {
    try {
      setLoading(true);
      const statsPromise = apiService.getAdminStats();
      const monetizationPromise = apiService
        .getAdminSubscriptionMetrics()
        .catch((error) => {
          console.warn('Subscription metrics unavailable:', error);
          return {};
        });

      const [stats, monetizationMetrics] = await Promise.all([
        statsPromise,
        monetizationPromise,
      ]);
      setMetrics({
        ...stats,
        ...monetizationMetrics,
      });
      setError('');
    } catch (err) {
      setError('Failed to load metrics');
      console.error('Error loading metrics:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = () => setError('');

  return {
    loading,
    error,
    metrics,
    setMetrics,
    loadMetrics,
    clearError,
  };
};
